module.exports = __webpack_public_path__ + "media/conmex/rfcs-e999792b.png";